exports.GB_POSTCODE_PATTERN = /^(GIR[ ]?0AA)|([a-zA-Z]{1,2}(([0-9]{1,2})|([0-9][a-zA-Z]))[ ]?[0-9][a-zA-Z]{2})$/;
exports.IE_POSTCODE_PATTERN = /^[a-zA-Z0-9 ]*$/;
exports.PHONE_PATTERN = /^\+?\d{7,15}$/;
exports.EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z0-9-]{1,}[A-Za-z0-9]))$/;
exports.COUNTRY_CODE = /^[A-Z][A-Z]$/;
